<template>
  <main class="c-home main-contain" id="pg-business-funding">
    <section id="home-banner" class="parallax-background" data-paroller-factor="-0.09" data-paroller-factor-sm="-0.09" data-paroller-factor-xs="-0.09" :style="{ background: 'url('+ banner +') no-repeat center top'}">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="banner_description">
              <h1 class="white-c-1">Dedicated Experts</h1>
              <p class="white-c-1 font-regular">Dan Advance has a team of experts, each dedicated to helping your business grow.</p>
              <a href="#BusinessFundingMain" class="banner_scroll" >Scroll down to explore</a>
            </div>
          </div>
        </div>
      </div>
    </section>


    <section id="BusinessFundingMain">
      <div class="container">
        <div class="row">
          <div class="col-md-7 matchHeight">
              <div class="padd-tb85">
                <h1 class="font-bold  mar-no blue-c-3">About Us</h1>
                <p class="padd-t30 font-regular justify">Dan Advance is the answer to small business financing. Located in the heart of the financial district in New York City, Dan Advance has a dedicated team that helps fund thousands of merchants in practically every industry. If you are a restaurant owner, a veterinarian, a salon owner, or own an auto repair business, we are here to help you.</p>
              </div>
          </div>
          <div class="col-md-4 col-md-offset-1 matchHeight" id="BlueLion">
            <div class="BlueContentWrap centerAlign">
              <h5>Solutions we offer</h5>
              <ul class="font-regular">
                <li><span>Business Loans</span></li>
                <li><span>Business Funding</span></li>
                <li><span>Cash Advances</span></li>
                <li><span>Credit Solutions and more</span></li>
              </ul>
              <p><router-link to="/apply-now" class="apply-btn">Apply Now</router-link></p>
            </div>
          </div>
        </div>
      </div>
    </section>




    <section id="WhyDanAdvance">
      <div class="container">
          <div class="row padd-tb35 whyMain">
            <div class="col-md-12">
              <h3 class="font-bold">Why Dan Advance?</h3>
              <p class="font-regular justify">Dan Advance is the answer to small business financing.  Located in the heart of the financial district in New York City, Dan Advance has a dedicated team that helps fund thousands of merchants in practically every industry. If you are a restaurant owner, a veterinarian, a salon owner, or own an auto repair business, we are here to help you.</p>
            </div>
          </div>
      </div>

      <div class="yellowBg">
        <div class="container">
            <div class="row">
              <div class="col-md-4 matchHeight GboderR">
                <h2 class="font-regular padd-tb35"><span class="small">What the</span>
                Small Business <br/> Administration <span class="small">has to say</span></h2>
              </div>
              <div class="col-md-8  matchHeight">
                 <div class="row centerAlign">
                    <div class="col-md-11 col-md-offset-1">
                      <p class="padd-tb35  font-regular justify">According to the Small Business Administration (SBA), “Inadequate or ill-timed financing is a major reason for small business-failure.”  Our objective is to provide the necessary working capital to help these businesses manage their cycles and existing cash flow and to provide them with carefully timed funding to assure their continued growth.</p>
                    </div>
                  </div>
              </div>
            </div>
        </div>
      </div>

      <br/><br/><br/>

    </section>


  </main>
</template>
<script>

import RwvSubscribe from '@/components/Subscribe'
export default{
  name: 'Home',
  components: {
    RwvSubscribe
  },
  data: function() {
    return {
      banner:require('./../../static/images/about-us.jpg')
    }
  },
  mounted() {

  }
}

</script>


// WEBPACK FOOTER //
// src/views/AboutUs.vue